/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import RouterHelper from '@/shared/utils/routerHelper';

import { Component, Vue } from 'vue-property-decorator';
import { DetailsOutline16 } from '@hb/coffee-icons';
import { Dialog } from '@hb/coffee';

import style from './index.module.scss';

const btnIcon = require('../tool-box/image/btn2.png');


@Component({ name: 'ToolBoxResult' })
export default class ToolBoxResult extends Vue {
  // 还款说明
  private onInfomation() {
    this.$ubtPageButton('贷款计算结果页_月还款金额说明');

    Dialog.alert({
      title: '月还款金额',
      message: '还款金额根据等额本息法计算得出',
      confirmButtonText: '知道了',
      closeable: false,
    });
  }

  // 申请借款
  private onBtnClick() {
    this.$ubtPageButton('贷款计算结果页_立即申请借款');
    RouterHelper.backHome();
  }

  private render() {
    return (
      <div class={style.ToolBoxResult}>
        <div class={style.main}>
          <div class={style.banner}>
            <div class={style.navbar}>
              <span>借款金额</span>
              <span>
                ¥{this.$route.query.loanAmt ? this.$route.query.loanAmt : ''}
              </span>
            </div>
            <div class={style.navbar}>
              <span>借款期数</span>
              <span>
                {this.$route.query.periods ? this.$route.query.periods : ''}期
              </span>
            </div>
            <div class={style.navbar}>
              <span>月利率</span>
              <span>
                {this.$route.query.rate ? this.$route.query.rate : ''}%
              </span>
            </div>
            <div class={style.bottom}>
              <div class={style.left}>
                <span>月还款金额</span>
                <DetailsOutline16
                  class={style.questionIcon}
                  onClick={() => this.onInfomation()}
                />
              </div>
              <span class={style.span}>
                ¥{this.$route.query.amount ? this.$route.query.amount : ''}
              </span>
            </div>
          </div>

          <div class={style.btn} onClick={() => this.onBtnClick()}>
            <img src={btnIcon} width="100%" />
          </div>
        </div>
      </div>
    );
  }
}
